import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { FormationCard } from '../components/FormationCard';
import { Cap360 } from '../components/Cap360';
import { CTABand } from '../components/CTABand';
import { FORMATIONS } from '../data/constants';
import { Info } from 'lucide-react';
import { Alert, AlertDescription } from '../components/ui/Alert';
export function FormationsList() {
  return <div className="flex flex-col w-full" data-id="element-1547" data-mp="136z1nwl2u2sf">
      <PageHeader title="Nos Formations en Alternance" subtitle="Découvrez nos parcours diplômants dans les domaines du commerce, de la vente et de la relation client." data-id="element-1548" data-mp="139uy1gha0jer" />

      <div className="py-24 bg-muted relative overflow-hidden" data-id="element-1549" data-mp="1c9qgm6d5vgot">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1550" data-mp="178at87nigy39" />
        <div className="container relative z-10" data-id="element-1551" data-mp="2npotklbgmmvb">
          <div className="max-w-4xl mx-auto mb-20" data-id="element-1552" data-mp="2ipakczy4h6vp">
            <Alert className="bg-white border-none shadow-xl p-8 rounded-3xl flex items-center gap-6 group hover:-translate-y-1 transition-transform" data-id="element-1553" data-mp="2iqlm6u80c4k6">
              <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1554" data-mp="2pcejoit38lzj">
                <Info className="h-8 w-8 text-brand-orange animate-soft-bounce" data-id="element-1555" data-mp="2uag4b865wtd4" />
              </div>
              <AlertDescription className="text-xl text-primary-dark font-extrabold leading-relaxed" data-id="element-1556" data-mp="2z8ztdhg1yl9p">
                Zillenium Alternance présente uniquement les formations ouvertes
                sur des sessions confirmées.
              </AlertDescription>
            </Alert>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto items-start" data-id="element-1557" data-mp="2bjyepcgmmdvz">
            {[...FORMATIONS].sort((a, b) => (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0)).map(formation => <div key={formation.id} className={formation.isNew ? 'md:col-span-2' : ''} data-id="element-1558" data-mp="1nvxdkols1zql">
                  <FormationCard formation={formation} data-id="element-1559" data-mp="1fty2qawxr1y3" />
                </div>)}
          </div>

          <div className="mt-12 max-w-3xl mx-auto" data-id="element-1560" data-mp="1btnlu37lur4g">
            <Cap360 data-id="element-1561" data-mp="1plu0fkv40q1s" />
          </div>
        </div>
      </div>

      <div className="mt-24" data-id="element-1562" data-mp="1pnf0fq071171">
        <CTABand title="Prêt à vous lancer ?" description="Rejoignez Zillenium Alternance et donnez vie à vos projets professionnels." primaryButtonText="Je candidate maintenant" primaryButtonLink="/candidater" secondaryButtonText="Je suis une entreprise" secondaryButtonLink="/entreprises" data-id="element-1563" data-mp="1klpjxuu7bvbk" />
      </div>
    </div>;
}